import { Flex, Radio } from "antd";
import React, { useEffect, useState } from "react";
import {
  DOMAIN_ID,
  ORG_ID,
  REACT_APP_API_TENANTS_URL,
} from "../../../constants";
import axios from "axios";

export default function ConditionalAccess({ message, tenantData }) {
  const [radioValue, setRadioValue] = useState("false");

  const options = [
    { label: "True", value: "true" },
    { label: "False", value: "false" },
  ];
  useEffect(() => {
    if (tenantData) {
      setRadioValue(tenantData.empowerAI === 1 ? "true" : "false");
    }
  }, [tenantData]);
  const handleConditionalAccessChange = async (e) => {
    const value = e.target.value; // "true" | "false"
    setRadioValue(value);
    const enabled = value === "true"; // convert to boolean

    const payload = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      empowerAI: enabled ? 1 : 0,
    };
    try {
      const response = await axios.post(
        `${REACT_APP_API_TENANTS_URL}/setTenantAI`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      message.success(
        `Conditional Access is now ${enabled ? "Enabled" : "Disabled"}.`,
      );
    } catch (error) {
      message.error(error.response?.data?.message || "Something went wrong");
    }
  };
  return (
    <div className="px-6 py-2 font-medium text-base">
      <Flex className="mt-2">
        <Radio.Group
          block
          options={options}
          value={radioValue}
          onChange={handleConditionalAccessChange}
        />
      </Flex>
    </div>
  );
}
